import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _abandonedCart = {
    abandonTime: 'google.protobuf.Timestamp',
    activities: '_activity',
};
var _activity = { timestamp: 'google.protobuf.Timestamp' };
var _deleteCartRequest = {};
var _deleteCartResponse = {};
var _getAbandonedCartRequest = {};
var _getAbandonedCartResponse = { abandonedCart: '_abandonedCart' };
var _queryAbandonedCartsRequest = {};
var _queryAbandonedCartsResponse = { abandonedCarts: '_abandonedCart' };
var _rawHttpResponse = { body: 'BYTES' };
var _redirectToCheckoutRequest = {};
function resolveWixCartAbandonmentApiV1AbandonedCartsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-cart-abandonment-web',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/abandoned-carts',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/abandonedCart',
                destPath: '/v1/abandonedCarts',
            },
            {
                srcPath: '/stores/v1/abandonedCarts',
                destPath: '/v1/abandonedCarts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/abandoned-carts',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns abandoned carts based on the cart ID */
export function getAbandonedCart(payload) {
    var _a = serializer(_getAbandonedCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAbandonedCartResponse, {
        _abandonedCart: _abandonedCart,
        _activity: _activity,
    }).fromJSON;
    function __getAbandonedCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.abandoned_cart',
            method: 'GET',
            methodFqn: 'wix.cart.abandonment.api.v1.AbandonedCarts.GetAbandonedCart',
            url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
                protoPath: '/v1/abandonedCarts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAbandonedCart.fromReq = fromReq;
    __getAbandonedCart.__isAmbassador = true;
    return __getAbandonedCart;
}
/** Returns abandoned carts based on the requested query parameters */
export function queryAbandonedCarts(payload) {
    var _a = serializer(_queryAbandonedCartsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAbandonedCartsResponse, {
        _abandonedCart: _abandonedCart,
        _activity: _activity,
    }).fromJSON;
    function __queryAbandonedCarts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.abandoned_cart',
            method: 'POST',
            methodFqn: 'wix.cart.abandonment.api.v1.AbandonedCarts.QueryAbandonedCarts',
            url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
                protoPath: '/v1/abandonedCarts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAbandonedCarts.fromReq = fromReq;
    __queryAbandonedCarts.__isAmbassador = true;
    return __queryAbandonedCarts;
}
/** Delete a cart by cart ID */
export function deleteCart(payload) {
    var _a = serializer(_deleteCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCartResponse, {}).fromJSON;
    function __deleteCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.abandoned_cart',
            method: 'DELETE',
            methodFqn: 'wix.cart.abandonment.api.v1.AbandonedCarts.DeleteCart',
            url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
                protoPath: '/v1/abandonedCarts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCart.fromReq = fromReq;
    __deleteCart.__isAmbassador = true;
    return __deleteCart;
}
/** Search abandonment cart/checkout by id and redirect to checkout page. */
export function redirectToCheckout(payload) {
    var _a = serializer(_redirectToCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __redirectToCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.abandoned_cart',
            method: 'GET',
            methodFqn: 'wix.cart.abandonment.api.v1.AbandonedCarts.RedirectToCheckout',
            url: resolveWixCartAbandonmentApiV1AbandonedCartsUrl({
                protoPath: '/v1/abandonedCarts/{id}/redirect-to-checkout',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redirectToCheckout.fromReq = fromReq;
    __redirectToCheckout.__isAmbassador = true;
    return __redirectToCheckout;
}
//# sourceMappingURL=http.impl.js.map